<template>
  <div id="app">
    <home />
  </div>
</template>
<script>
import home from '@/views/IFindHome';

export default {
  name: 'App',
  components: {
    home
  },
  data() {
    return {};
  }
};
</script>
<style lang="less">
#app {
  overflow-x: auto;
  height: 100%;
  background: #ffffff;
}
</style>
